import {DestroyRef, inject, Inject, Injectable} from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { Togglz } from '../models/Togglz';
import { HttpClient } from '@angular/common/http';
import {ApiUrl} from '@emm/core/util/api-url.token';

@Injectable()
export class TogglzService {
    private _allFeatureTogglz: Togglz[] = [];
    private togglz: Observable<Togglz[]>;
    private newFileGenTogglz = new BehaviorSubject<boolean>(false);
    private readonly destroyRef: DestroyRef = inject(DestroyRef);


    constructor(@Inject(ApiUrl) private apiUrl: string, private http: HttpClient) {}
}
